//===============================================================================
// © 2017 eWorkplace Apps.  All rights reserved.
// Original Author: Sanjeev Khanna
// Original Date: 10 June 2017
//==============================================================================
import { CommonHelper } from "./common.helper";
import { UserDc } from '../models/login/user-dc';
import { CustomerNegativeAccountHistoryMinDc } from '../../crm/models/htmldata/customer-negative-account-history-min-dc.model';
import { RaiseDisupteAccount } from '../../crm/models/contact/raise-disupte-account.model';
import { HtmlInquiriesDc } from '../../crm/models/htmldata/html-inquiries-dc.model';
import { RaiseDisputeDc } from '../../crm/models/htmldata/raise-dispute-dc.model';
import { CustomerSession } from "../models/login/customer-session";
import * as CryptoJS from 'crypto-js';
import { BehaviorSubject } from 'rxjs';

/**
 * This class provides the helper method to manage session varialbe in local storage and static object.
 */
export class SessionHelper {

    /**
     * Static variables which will store session values like access token,login flag,user session object,user other info object.
     */

    private static isLogin: boolean;
    private static userId: Number;
    private static userName: string;
    private static loginName: string;
    private static userType: string;
    private static userTypeId: Number;
    private static affiliateTypeId: Number;
    private static authenticationId: Number;
    private static userDc: UserDc;

    private static customerSession: CustomerSession;
    private static AffiliateDisplayPortalId: Number;
    private static affiliateSession: any = {};
    private encryptSecretKey = "A<K9A>@HNS^Mjfu";
    userProfileDetail: any;
    static userProfileDetail: any;
    static encryptSecretKey: any;

    /**
     * Method to set IsLogin flag value in local session storage with key.
     * @param value: True, if already login else false
     */
    static setIsLogin(value: boolean) {
        this.isLogin = value;
        //console.log("Set IsLogin: " + this.isLogin);
        localStorage.setItem("IsLogin", this.isLogin.toString());
    }

    /**
     * Method to get IsLogin flag value from local session storage with key.
     */
    static getIsLogin(): boolean {
        if (this.isLogin == undefined) {
            //console.log("get IsLogin from session");
            this.isLogin = JSON.parse(localStorage.getItem("IsLogin"));
        }

        if (this.isLogin == null)
            this.isLogin = false;

        // console.log("IsLogin: " + this._isLogin);
        return this.isLogin;
    }




    /**
     * Method to set user other info object value in local session storage with key.
     * @param res
     */
    static setUser(userDc: UserDc) {
        if (userDc.UserType == "Customer") {
            this.customerSession = new CustomerSession();
            this.customerSession.userDc = userDc;
            this.customerSession.userDc.FullName = userDc.FirstName + (userDc.LastName != "" ? " " + userDc.LastName : "");
            this.customerSession.isLogin = true;
            this.customerSession.userId = userDc.UserId;
            this.customerSession.userName = userDc.UserName;
            this.customerSession.userType = userDc.UserType;
            this.customerSession.authenticationId = userDc.AuthenticationId;
            this.customerSession.userName = userDc.FullName;
            this.customerSession.userTypeId = userDc.UserTypeId;
            this.customerSession.customerPortal = userDc.CustomerPortal;
            localStorage.setItem("CustomerSession", JSON.stringify(this.customerSession));
            this.setCustomerHasLeftCRMStatus(this.customerSession.userDc.HasCustomerLeftCRM);
            this.setIsLogin(true);
        }
        else {
            this.userDc = userDc;
            userDc.FullName = userDc.FirstName + (userDc.LastName != "" ? " " + userDc.LastName : "");
            let strUserOtherInfo: string = JSON.stringify(userDc);
            localStorage.setItem("User", strUserOtherInfo);
            this.setIsLogin(true);
            this.setUserId(userDc.UserId);
            this.setUserName(userDc.UserName);
            this.setUserType(userDc.UserType);
            this.setAuthenticationId(userDc.AuthenticationId);
            this.setLoginName(userDc.FullName);
            this.setUserTypeId(userDc.UserTypeId);
            if (userDc.AffiliateTypeId != null) {
                this.affiliateTypeId = userDc.AffiliateTypeId;
                this.setAffiliateTypeId(userDc.AffiliateTypeId);
            }
        }
        if (userDc.UserType == "Affiliate") {
            localStorage.setItem("AffiliateSession", JSON.stringify(this.userDc));
        }
    }

    /**
   * Method to get user other info object value from local session storage with key.
   */
    static getUser(): UserDc {
        if (this.userDc == null) {
            this.userDc = <UserDc>JSON.parse(localStorage.getItem("User"));
        }
        if (this.userDc == null) {
            this.userDc = new UserDc();
        }
        return this.userDc;
    }

    /**
  * Method to get user role Id from local session storage with key.
  */
    static getUserRoleId(): Number {
        if (this.userDc == null) {
            this.userDc = <UserDc>JSON.parse(localStorage.getItem("User"));
        }
        if (this.userDc == null) {
            this.userDc = new UserDc();
        }
        return this.userDc.RoleId;
    }

    /**
     *Method to set login AuthToken session value in local session storage with key.
     * @param authToken: EwpAccess token
     */
    static setUserId(userId: Number) {
        this.userId = userId;
        localStorage.setItem("UserId", this.userId.toString());
    }

    static setUserName(userName: string) {
        this.userName = userName;
        localStorage.setItem("UserName", this.userName.toString());
    }

    static setUserType(userType: string) {
        this.userType = userType;
        localStorage.setItem("UserType", this.userType.toString());
    }
    static setAuthenticationId(authenticationId: Number) {
        this.authenticationId = authenticationId;
        localStorage.setItem("AuthenticationId", this.authenticationId.toString());
    }

    static setLoginName(loginName: string) {
        this.loginName = loginName;
        localStorage.setItem("LoginName", this.loginName.toString());
    }

    static setUserTypeId(userTypeId: Number) {
        if (userTypeId) {
            this.userTypeId = userTypeId;
            localStorage.setItem("UserTypeId", this.userTypeId.toString());
        }
    }

    static setAffiliateTypeId(affiliateTypeId: Number) {
        if (affiliateTypeId) {
            this.affiliateTypeId = affiliateTypeId;
            localStorage.setItem("AffiliateTypeId", this.affiliateTypeId.toString());
        }
    }

    /**
     * Method which get login AuthToken session value from local session storage with key.
     */
    static getUserId(): number {
        // If token is undefined then get from local storage
        if (this.userId == undefined) {
            this.userId = CommonHelper.convertStringToNumber(localStorage.getItem("UserId"));
        }
        // After logout the token is defined
        if (this.userId != undefined && localStorage.getItem("UserId") == null) {
            this.userId = 0;
        }
        // If token is null in local storage
        if (this.userId == null)
            this.userId = 0;

        return +(this.userId);
    }


    /**
    * Method which get login AuthToken session value from local session storage with key.
    */
    static getAffiliateProgramId(): number {
        if (this.userDc == null) {
            this.userDc = <UserDc>JSON.parse(localStorage.getItem("User"));
        }
        if (this.userDc == null) {
            this.userDc = new UserDc();
        }
        return this.userDc.ProgramId;
    }

    static getUserName(): string {
        // If token is undefined then get from local storage
        if (this.userName == undefined) {
            this.userName = (localStorage.getItem("UserName"));
        }
        // After logout the token is defined
        if (this.userName != undefined && localStorage.getItem("UserName") == null) {
            this.userName = "";
        }
        // If token is null in local storage
        if (this.userName == null)
            this.userName = "";

        return this.userName;
    }


    static getUserType(): string {
        // If token is undefined then get from local storage
        if (this.userType == undefined) {
            this.userType = (localStorage.getItem("UserType"));
        }
        // After logout the token is defined
        if (this.userType != undefined && localStorage.getItem("UserType") == null) {
            this.userType = "";
        }
        // If token is null in local storage
        if (this.userType == null)
            this.userType = "";

        return this.userType;
    }

    static getAuthenticationId(): Number {
        // If token is undefined then get from local storage
        if (this.authenticationId == undefined) {
            this.authenticationId = CommonHelper.convertStringToNumber(localStorage.getItem("AuthenticationId"));
        }
        // After logout the token is defined
        if (this.authenticationId != undefined && localStorage.getItem("AuthenticationId") == null) {
            this.authenticationId = 0;
        }
        // If token is null in local storage
        if (this.authenticationId == null)
            this.authenticationId = 0;

        return this.authenticationId;
    }

    static getLoginName(): string {
        // If token is undefined then get from local storage
        if (this.loginName == undefined) {
            this.loginName = (localStorage.getItem("LoginName"));
        }
        // After logout the token is defined
        if (this.loginName != undefined && localStorage.getItem("LoginName") == null) {
            this.loginName = "";
        }
        // If token is null in local storage
        if (this.loginName == null)
            this.loginName = "";

        return this.loginName;
    }

    public static getUserFullName() {
        return this.userDc.FullName;
    }

    static getUserTypeId(): Number {
        // If token is undefined then get from local storage
        if (this.userTypeId == undefined) {
            this.userTypeId = CommonHelper.convertStringToNumber(localStorage.getItem("UserTypeId"));
        }
        // After logout the token is defined
        if (this.userTypeId != undefined && localStorage.getItem("UserTypeId") == null) {
            this.userTypeId = 0;
        }
        // If token is null in local storage
        if (this.userTypeId == null)
            this.userTypeId = 0;

        return this.userTypeId;
    }

    static getAffiliateTypeId(): Number {
        // If token is undefined then get from local storage
        if (this.affiliateTypeId == undefined) {
            this.affiliateTypeId = CommonHelper.convertStringToNumber(localStorage.getItem("AffiliateTypeId"));
        }
        // After logout the token is defined
        if (this.affiliateTypeId != undefined && localStorage.getItem("AffiliateTypeId") == null) {
            this.affiliateTypeId = 0;
        }
        // If token is null in local storage
        if (this.affiliateTypeId == null)
            this.affiliateTypeId = 0;

        return this.affiliateTypeId;
    }

    static getAffiliateTeamLeadId(): Number {
        if (this.userDc == null) {
            this.userDc = <UserDc>JSON.parse(localStorage.getItem("User"));
        }
        if (this.userDc == null) {
            this.userDc = new UserDc();
        }
        return this.userDc.TeamLeadId;
    }

    static getAffiliateTeamLeadName(): string {
        if (this.userDc == null) {
            this.userDc = <UserDc>JSON.parse(localStorage.getItem("User"));
        }
        if (this.userDc == null) {
            this.userDc = new UserDc();
        }
        return this.userDc.TeamLeadName;
    }
    /**
   * Method to clear all local session values from local storage by corresponding keys.
   */
    static clearSession() {
        this.customerSession = this.getCustomerSession();
        sessionStorage.clear();
        localStorage.clear();
        SessionHelper.isLogin = false;
        if (this.customerSession && this.customerSession.isLogin == true) {
            localStorage.setItem("CustomerSession", JSON.stringify(this.customerSession));
            this.setIsLogin(true);
        }
    }

    // static clearSession() {
    //     sessionStorage.removeItem("AffiliateSearchPerameters");
    //     sessionStorage.removeItem("AuthenticationId");
    //     sessionStorage.removeItem("CustomerUniqueId");
    //     sessionStorage.removeItem("IsLogin");
    //     sessionStorage.removeItem("LoginName");
    //     sessionStorage.removeItem("SelectedAffiliateId");
    //     sessionStorage.removeItem("SelectedContactTypeId");
    //     sessionStorage.removeItem("SelectedCustomerId");
    //     sessionStorage.removeItem("SelectedCustomerName");
    //     sessionStorage.removeItem("SelectedSearchPerameters");
    //     sessionStorage.removeItem("UserId");
    //     sessionStorage.removeItem("UserName");
    //     sessionStorage.removeItem("UserType");
    //     sessionStorage.removeItem("UserTypeId");
    //     SessionHelper.isLogin = false;
    // }


    /**
     * Clear session from local storage by specified key.
     * @param key
     */
    static clearSessionByKey(key: string) {
        localStorage.removeItem(key);
    }

    /////////////// Set Selected CustomerId /////////////////////////////
    static SelectedCustomerId: Number;

    static setSelectedCustomerId(CustomerId: Number) {
        this.SelectedCustomerId = CustomerId;
        localStorage.setItem("SelectedCustomerId", this.SelectedCustomerId.toString());
    }

    static getSelectedCustomerId(): Number {
        if (this.SelectedCustomerId == undefined) {
            this.SelectedCustomerId = CommonHelper.convertStringToNumber(localStorage.getItem("SelectedCustomerId"));
        }
        // If token is null in local storage
        if (this.SelectedCustomerId == null)
            this.SelectedCustomerId = 0;

        return this.SelectedCustomerId;
    }

    /////////////// Set back button  /////////////////////////////
    static CheckBackButton: string;

    static setCheckBackButton(checkButton: string) {
        this.CheckBackButton = checkButton;
        localStorage.setItem("CheckBackButton", this.CheckBackButton.toString());
    }

    static getCheckBackButton(): string {
        if (this.CheckBackButton == undefined) {
            this.CheckBackButton = localStorage.getItem("CheckBackButton");
        }
        return this.CheckBackButton;
    }
    static clearSessionForBackButton() {
        sessionStorage.removeItem("CheckBackButton");
        localStorage.removeItem("CheckBackButton");
        SessionHelper.CheckBackButton = null;
    }

    /////////////////////Customer Name//////////////
    static SelectedCustomerName: string;

    static setSelectedCustomerName(CustomerName: string) {
        this.SelectedCustomerName = CustomerName;
        localStorage.setItem("SelectedCustomerName", this.SelectedCustomerName.toString());
    }

    static getSelectedCustomerName(): string {
        if (this.SelectedCustomerName == undefined) {
            this.SelectedCustomerName = (localStorage.getItem("SelectedCustomerName"));
        }
        // If token is null in local storage

        return this.SelectedCustomerName;
    }

    ////////////////////// Customer Unique Id /////////////////

    static CustomerUniqueId: string;
    static setCustomerUniqueId(CustomerUniqueId: string) {
        this.CustomerUniqueId = CustomerUniqueId;
        localStorage.setItem("CustomerUniqueId", this.CustomerUniqueId.toString());
    }

    static getCustomerUniqueId(): string {
        if (this.CustomerUniqueId == undefined) {
            this.CustomerUniqueId = (localStorage.getItem("CustomerUniqueId"));
        }
        // If token is null in local storage

        return this.CustomerUniqueId;
    }
    /////////////// Set Search perameter in contact page/////////////////////////////
    static SelectedSearchPerameters: any;

    static setSearchPerametersForContactList(searchPerameters: any) {
        this.SelectedSearchPerameters = searchPerameters;
        localStorage.setItem("SelectedSearchPerameters", this.SelectedSearchPerameters.toString());
    }

    static getSearchPerametersForContactList(): any {
        if (this.SelectedSearchPerameters == undefined) {
            this.SelectedSearchPerameters = localStorage.getItem("SelectedSearchPerameters");
        }
        return this.SelectedSearchPerameters;
    }
    static clearSessionForSearchPerameters() {
        sessionStorage.removeItem("SelectedSearchPerameters");
        localStorage.removeItem("SelectedSearchPerameters");
        SessionHelper.SelectedSearchPerameters = null;
    }


    static dashboardSearchCriteria: any;

    static setDashboardSearchCriteria(searchPerameters: any) {
        this.dashboardSearchCriteria = searchPerameters;
        localStorage.setItem("DashboardSearchCriteria", JSON.stringify(this.dashboardSearchCriteria));
    }

    static getDashboardSearchCriteria(): any {
        if (this.dashboardSearchCriteria == undefined) {
            this.dashboardSearchCriteria = JSON.parse(localStorage.getItem("DashboardSearchCriteria"));
        }
        return this.dashboardSearchCriteria;
    }
    static clearDashboardSearchCretirea() {
        sessionStorage.removeItem("DashboardSearchCriteria");
        localStorage.removeItem("DashboardSearchCriteria");
        this.dashboardSearchCriteria = null;
    }

    /////////////// Set Contact Type in contact page/////////////////////////////
    static SelectedContactTypeId: string;
    static setSelectedContactTypeId(ContactTypeId: string) {
        this.SelectedContactTypeId = ContactTypeId;
        localStorage.setItem("SelectedContactTypeId", this.SelectedContactTypeId.toString());
    }

    static getSelectedContactTypeId(): string {
        if (this.SelectedContactTypeId == undefined) {
            this.SelectedContactTypeId = localStorage.getItem("SelectedContactTypeId");
        }
        return this.SelectedContactTypeId;
    }
    static clearSessionForContactTypeId() {
        sessionStorage.removeItem("SelectedContactTypeId");
        localStorage.removeItem("SelectedContactTypeId");
        SessionHelper.SelectedContactTypeId = null;
    }

    /////////////// Set Contact Type in contact page/////////////////////////////
    static SelectedContactBackUrl: string;
    static setContactBackUrl(ContactBackUrl: string) {
        this.SelectedContactBackUrl = ContactBackUrl;
        localStorage.setItem("SelectedContactBackUrl", this.SelectedContactBackUrl.toString());
    }

    static getSelectedContactBackUrl(): string {
        if (this.SelectedContactBackUrl == undefined) {
            this.SelectedContactBackUrl = localStorage.getItem("SelectedContactBackUrl");
        }
        return this.SelectedContactBackUrl;
    }
    static clearSessionForContactBackUrl() {
        sessionStorage.removeItem("SelectedContactBackUrl");
        localStorage.removeItem("SelectedContactBackUrl");
        SessionHelper.SelectedContactBackUrl = null;
    }

    /////////////// Set Contact Type in contact page/////////////////////////////
    static SelectedAffiliateBackUrl: string;
    static setAffiliateBackUrl(AffiliateBackUrl: string) {
        this.SelectedAffiliateBackUrl = AffiliateBackUrl;
        localStorage.setItem("SelectedAffiliateBackUrl", this.SelectedAffiliateBackUrl.toString());
    }

    static getSelectedAffiliateBackUrl(): string {
        if (this.SelectedAffiliateBackUrl == undefined) {
            this.SelectedAffiliateBackUrl = localStorage.getItem("SelectedAffiliateBackUrl");
        }
        return this.SelectedAffiliateBackUrl;
    }
    static clearSessionForAffiliateBackUrl() {
        sessionStorage.removeItem("SelectedAffiliateBackUrl");
        localStorage.removeItem("SelectedAffiliateBackUrl");
        SessionHelper.SelectedAffiliateBackUrl = null;
    }

    /////////////// Set Employee filter in Dashboard/////////////////////////////
    static SelectedEmployeeId: Number;
    static setSelectedEmployeeId(EmployeeId: Number) {
        this.SelectedEmployeeId = EmployeeId;
        localStorage.setItem("SelectedEmployeeId", this.SelectedEmployeeId.toString());
    }
    static getSelectedEmployeeId(): any {
        if (this.SelectedEmployeeId == undefined) {
            this.SelectedEmployeeId = CommonHelper.convertStringToNumber(localStorage.getItem("SelectedEmployeeId"));
        }
        return this.SelectedEmployeeId;
    }
    static clearSessionForEmployeeId() {
        sessionStorage.removeItem("SelectedEmployeeId");
        localStorage.removeItem("SelectedEmployeeId");
        SessionHelper.SelectedEmployeeId = null;
    }

    /////////////// Set Task Category filter in Dashboard/////////////////////////////
    static SelectedTaskCategoryId: Number;
    static setSelectedTaskCategoryId(TaskCategoryId: Number) {
        this.SelectedTaskCategoryId = TaskCategoryId;
        localStorage.setItem("SelectedTaskCategoryId", this.SelectedTaskCategoryId.toString());
    }

    static getSelectedTaskCategoryId(): any {
        if (this.SelectedTaskCategoryId == undefined) {
            this.SelectedTaskCategoryId = Number(localStorage.getItem("SelectedTaskCategoryId"));
        }
        return this.SelectedTaskCategoryId;
    }
    static clearSessionForTaskCategoryId() {
        sessionStorage.removeItem("SelectedTaskCategoryId");
        localStorage.removeItem("SelectedTaskCategoryId");
        SessionHelper.SelectedTaskCategoryId = null;
    }


    ///////// For Affiliate Id ////////////////

    static SelectedAffiliateId: Number;
    static setSelectedAffiliateId(AffiliateId: Number) {
        this.SelectedAffiliateId = AffiliateId;
        localStorage.setItem("SelectedAffiliateId", this.SelectedAffiliateId.toString());
    }

    static getSelectedAffiliateId(): Number {
        if (this.SelectedAffiliateId == undefined) {
            this.SelectedAffiliateId = CommonHelper.convertStringToNumber(localStorage.getItem("SelectedAffiliateId"));
        }
        // If token is null in local storage
        if (this.SelectedAffiliateId == null)
            this.SelectedAffiliateId = 0;

        return this.SelectedAffiliateId;
    }

    static SelectedAffiliateInfo: Number;
    static setSelectedAffiliateInfo(PortalInfo: any) {
        this.SelectedAffiliateInfo = PortalInfo;
        localStorage.setItem("SelectedAffiliateInfo", JSON.stringify(this.SelectedAffiliateInfo));
    }
    static getSelectedAffiliateInfo() {
        if (this.SelectedAffiliateInfo == undefined) {
            let value = JSON.parse(localStorage.getItem("SelectedAffiliateInfo"));
            this.SelectedAffiliateInfo = value;
        } else {
            this.SelectedAffiliateInfo = null;
        }
        return this.SelectedAffiliateInfo;
    }

    static selectedContactFileInfo: any;
    static setSelectedContactFileInfo(PortalInfo: any) {
        this.selectedContactFileInfo = PortalInfo;
        localStorage.setItem("SelectedContactFileInfo", JSON.stringify(this.selectedContactFileInfo));
    }
    static getSelectedContactFileInfo() {
        let contactInfo = localStorage.getItem("SelectedContactFileInfo");
        if (contactInfo) {
            let value = JSON.parse(localStorage.getItem("SelectedContactFileInfo"));
            this.selectedContactFileInfo = value;
        } else {
            this.selectedContactFileInfo = null;
        }
        return this.selectedContactFileInfo;
    }

    ///////// For Affiliate Portal -Contact Id ////////////////
    static SelectedAffiPortContactId: Number;
    static setSelectedAffiPortContactId(AffiPortContactId: Number) {
        this.SelectedAffiPortContactId = AffiPortContactId;
        localStorage.setItem("SelectedAffiPortContactId", this.SelectedAffiPortContactId.toString());
    }

    static getSelectedAffiPortContactId(): Number {
        if (this.SelectedAffiPortContactId == undefined) {
            this.SelectedAffiPortContactId = CommonHelper.convertStringToNumber(localStorage.getItem("SelectedAffiPortContactId"));
        }
        // If token is null in local storage
        if (this.SelectedAffiPortContactId == null)
            this.SelectedAffiPortContactId = 0;

        return this.SelectedAffiPortContactId;
    }

    ///////// For Affiliate Portal -Contact Name ////////////////
    static SelectedAffiPortContactName: any;
    static setSelectedAffiPortContactName(AffiPortContactName: String) {
        this.SelectedAffiPortContactName = AffiPortContactName;
        localStorage.setItem("SelectedAffiPortContactName", this.SelectedAffiPortContactName.toString());
    }

    static getSelectedAffiPortContactName(): any {
        if (this.SelectedAffiPortContactName == undefined) {
            this.SelectedAffiPortContactName = localStorage.getItem("SelectedAffiPortContactName");
        }
        // If token is null in local storage
        if (this.SelectedAffiPortContactName == null)
            this.SelectedAffiPortContactName = "";

        return this.SelectedAffiPortContactName;
    }

    static contactAffPortalDisplayId: any;
    static setContactAffPortalDisplayId(portalDisplayId: Number) {
        this.contactAffPortalDisplayId = portalDisplayId;
        localStorage.setItem("ContactAffPortalDisplayId", this.contactAffPortalDisplayId.toString());
    }

    static getContactAffPortalDisplayId(): any {
        if (this.contactAffPortalDisplayId == undefined) {
            this.contactAffPortalDisplayId = localStorage.getItem("ContactAffPortalDisplayId");
        }
        // If token is null in local storage
        if (this.contactAffPortalDisplayId == null)
            this.contactAffPortalDisplayId = 0;

        return this.contactAffPortalDisplayId;
    }

    /////////////// Set Search perameter in contact page/////////////////////////////
    static AffiliateSearchPerameters: any;

    static setSearchPerametersForAffiliateList(affiliateSearchPerameters: any) {
        this.AffiliateSearchPerameters = affiliateSearchPerameters;
        localStorage.setItem("AffiliateSearchPerameters", this.AffiliateSearchPerameters.toString());
    }

    static getSearchPerametersForAffiliateList(): any {
        if (this.AffiliateSearchPerameters == undefined) {
            this.AffiliateSearchPerameters = localStorage.getItem("AffiliateSearchPerameters");
        }
        return this.AffiliateSearchPerameters;
    }
    static clearSessionForAffiliateSearchPerameters() {
        sessionStorage.removeItem("AffiliateSearchPerameters");
        localStorage.removeItem("AffiliateSearchPerameters");
        SessionHelper.AffiliateSearchPerameters = null;
    }


    //////////////// Customer Negative Accoun tHistory Min Dc //////////////////////////
    static customerNegativeAccountHistoryMinDcs: Array<CustomerNegativeAccountHistoryMinDc>;

    static setCustomerNegativeAccountHistory(customerNegativeAccountHistoryMinDcs: Array<CustomerNegativeAccountHistoryMinDc>) {
        this.customerNegativeAccountHistoryMinDcs = customerNegativeAccountHistoryMinDcs;
        localStorage.setItem("CustomerNegativeAccountHistory", JSON.stringify(this.customerNegativeAccountHistoryMinDcs));
    }

    static getCustomerNegativeAccountHistory(): Array<CustomerNegativeAccountHistoryMinDc> {
        if (this.customerNegativeAccountHistoryMinDcs == undefined) {
            let value = JSON.parse(localStorage.getItem("CustomerNegativeAccountHistory"));
            this.customerNegativeAccountHistoryMinDcs = value
        }
        // If token is null in local storage
        if (this.customerNegativeAccountHistoryMinDcs == null)
            this.customerNegativeAccountHistoryMinDcs = [];
        return this.customerNegativeAccountHistoryMinDcs;
    }


    //////////////// Enquiries Dc //////////////////////////
    static inquiriesDcs: Array<HtmlInquiriesDc>;

    static setInquiries(inquiriesDcs: Array<HtmlInquiriesDc>) {
        this.inquiriesDcs = inquiriesDcs;
        localStorage.setItem("Inquiries", JSON.stringify(this.inquiriesDcs));
    }

    static getInquiries(): Array<HtmlInquiriesDc> {
        if (this.inquiriesDcs == undefined) {
            let value = JSON.parse(localStorage.getItem("Inquiries"));
            this.inquiriesDcs = value
        }

        if (this.inquiriesDcs == null) {
            this.inquiriesDcs = [];
        }
        return this.inquiriesDcs;
    }

    //////////////// Customer Negative Accoun tHistory Min Dc //////////////////////////
    static raiseDisupteAccount: RaiseDisupteAccount;

    static setRaiseDisupteAccount(selectedAccountDcs: RaiseDisupteAccount) {
        this.raiseDisupteAccount = selectedAccountDcs;
        localStorage.setItem("RaiseDisupteAccount", JSON.stringify(this.raiseDisupteAccount));
    }

    static getRaiseDisupteAccount(): RaiseDisupteAccount {
        if (this.raiseDisupteAccount == undefined) {
            let value = JSON.parse(localStorage.getItem("RaiseDisupteAccount"));
            this.raiseDisupteAccount = value
        }
        // If token is null in local storage
        if (this.raiseDisupteAccount == null)
            this.raiseDisupteAccount = new RaiseDisupteAccount;
        return this.raiseDisupteAccount;
    }

    //////////////// Customer Negative Accoun tHistory Min Dc //////////////////////////
    static enqRaiseDisupteAccount: RaiseDisupteAccount;

    static setEnqRaiseDisupteAccount(selectedAccountDcs: RaiseDisupteAccount) {
        this.enqRaiseDisupteAccount = selectedAccountDcs;
        localStorage.setItem("EnqRaiseDisupteAccount", JSON.stringify(this.raiseDisupteAccount));
    }

    static getEnqRaiseDisupteAccount(): RaiseDisupteAccount {
        if (this.enqRaiseDisupteAccount == undefined) {
            let value = JSON.parse(localStorage.getItem("EnqRaiseDisupteAccount"));
            this.enqRaiseDisupteAccount = value
        }
        // If token is null in local storage
        if (this.enqRaiseDisupteAccount == null)
            this.enqRaiseDisupteAccount = new RaiseDisupteAccount;
        return this.enqRaiseDisupteAccount;
    }

    //////////////// Raise Dispute //////////////////////////
    static raiseDisputeDc: RaiseDisputeDc;

    static setRaiseDispute(raiseDisputeDc: RaiseDisputeDc) {
        this.raiseDisputeDc = raiseDisputeDc;
        localStorage.setItem("RaiseDisputeDc", JSON.stringify(this.raiseDisputeDc));
    }

    static getRaiseDispute(): RaiseDisputeDc {
        if (this.raiseDisputeDc == undefined) {
            let value = JSON.parse(localStorage.getItem("RaiseDisputeDc"));
            this.raiseDisputeDc = value
        }
        // If token is null in local storage
        if (this.raiseDisputeDc == null)
            this.raiseDisputeDc = new RaiseDisputeDc();
        return this.raiseDisputeDc;
    }

    // Customer Session
    static getCustomerSession(): CustomerSession {
        if (!this.customerSession) {
            this.customerSession = JSON.parse(localStorage.getItem("CustomerSession"));
        }
        if (!this.customerSession) {
            this.customerSession = new CustomerSession;
        }
        return this.customerSession;
    }

    static getCustomerIsLogin(): boolean {
        return this.getCustomerSession().isLogin;
    }

    static setNatigateFromLogin() {
        localStorage.setItem("NavigateFromLogin", "No");
    }

    static isNavigateFromLogin(){
       return localStorage.getItem("NavigateFromLogin") ? false : true;
    }

    static setContactRound(roundId: Number){
      localStorage.setItem("ContactRound", roundId.toString());
    }

    static getContactRound(){
      return localStorage.getItem("ContactRound");
   }

    public static getCustomerUserFullName() {
        return this.getCustomerSession().userDc.FullName;
    }

    static getCustomerLoginUserName(): string {
        return this.getCustomerSession().loginName;
    }

    static getCustomerUserId(): Number {
        return this.getCustomerSession().userId;
    }

    static getCustomerLoginName(): string {
        return this.getCustomerSession().loginName;
    }

    static getCustomerPortal(): number {
        return this.getCustomerSession().customerPortal;
    }

    /**
   * Method to clear all local session values from local storage by corresponding keys.
   */
    static clearCustomerSession(clearAll = true) {
        if (!this.userDc && clearAll) {
            sessionStorage.clear();
            localStorage.clear();
            SessionHelper.isLogin = false;
        }
        else {
            localStorage.removeItem("CustomerSession");
            this.customerSession = null;
        }
    }

    static getCustomerUser(): UserDc {
        return this.getCustomerSession().userDc;
    }

    static isProfileSetUpCompleted(): boolean {
        let isSetUpCompleted = localStorage.getItem("IsSetUpCompleted");
        if (isSetUpCompleted) {
            return true;
        } else {
            const user = this.getCustomerSession().userDc;
            return user && user.IsSetUpCompleted;
        }
    }

    static isCreditReportUploaded(): boolean {
        const isCreditReportUploaded = localStorage.getItem("IsCreditReportUploaded");
        const isActive = localStorage.getItem('CMStatus');
        if (isCreditReportUploaded || isActive == 'Active') {
            return true;
        } else {
            const user = this.getCustomerSession().userDc;
            return (user && (user.IsCreditReportUploaded || user.CMStatus == 'Active')) ? true : false;
        }
    }

    static isSSNAvailable(): boolean {
        let isSSNAvailable = localStorage.getItem("IsSSNAvailable");
        if (isSSNAvailable) {
            return isSSNAvailable == 'true' ? true : false;
        } else {
            const user = this.getCustomerSession().userDc;
            return user && user.IsSSNAvailable;
        }
    }

    static setSSNAvailable(value = 'true') {
        localStorage.setItem("IsSSNAvailable", value);
    }

    static completeProfileSetUp(): void {
        localStorage.setItem("IsSetUpCompleted", 'true');
    }

    static setIsCreditReportUploaded(): void {
        localStorage.setItem("IsCreditReportUploaded", 'true');
        localStorage.setItem("CMStatus", 'Active');
    }

    static getBotStrategyStatus(): string {
        let botStrategy = localStorage.getItem("BotStrategy");
        if (botStrategy != null) {
            return botStrategy;
        } else {
            const user = this.getCustomerSession().userDc;
            return user && user.BotStrategies;
        }
    }

    static setBotStrategyStatus(): void {
        localStorage.setItem("BotStrategy", "Complete");
    }

    static getBotTeamStatus(): any {
        let botTeams = localStorage.getItem("BotTeams");
        if (botTeams != null) {
            return botTeams;
        } else {
            const user = this.getCustomerSession().userDc;
            return user && user.BotTeams;
        }
    }

    static setBotTeamStatus(): void {
        localStorage.setItem("BotTeams", "Complete");
    }

    static isAffiliateProfileSetUp(): boolean {
        let isAffiliateProfileSetUp = localStorage.getItem("IsAffiliateProfileSetUp");
        if (isAffiliateProfileSetUp) {
            return true;
        } else {
            const user = this.getUser();
            return user && user.IsSetUpCompleted;
        }
    }

    static setCompleteAffiliateProfile() {
        localStorage.setItem("IsAffiliateProfileSetUp", 'true');
    }

    static isAffiliateVisitedProfile(): boolean {
        let isAffiliateVisitedProfile = localStorage.getItem("isAffiliateVisitedProfile");
        if (isAffiliateVisitedProfile) {
            return true;
        } else {
            return false;
        }
    }

    static setAffiliateVisitedProfile() {
        localStorage.setItem("isAffiliateVisitedProfile", 'true');
    }


    static isCreditMonitorPopupShown(): boolean {
        let isCreditMonitorPopupShown = localStorage.getItem("isCreditMonitorPopupShown");
        if (isCreditMonitorPopupShown) {
            return true;
        } else {
            return false;
        }
    }

    static setCreditMonitorPopupShown() {
        localStorage.setItem("isCreditMonitorPopupShown", 'true');
    }

    /////////////// Set Search perameter in contact page/////////////////////////////
    static SelecteBillingSearchPerameter: any;

    static setSearchPerametersForBillingSummary(searchBillingPerameters: any) {
        this.SelecteBillingSearchPerameter = searchBillingPerameters;
        localStorage.setItem("SelecteBillingSearchPerameter", this.SelecteBillingSearchPerameter.toString());
    }

    static getSearchPerametersForBillingSummary(): any {
        if (this.SelecteBillingSearchPerameter == undefined) {
            this.SelecteBillingSearchPerameter = localStorage.getItem("SelecteBillingSearchPerameter");
        }
        return this.SelecteBillingSearchPerameter;
    }

    static clearSessionForBillingSummaryPerameters() {
        sessionStorage.removeItem("SelecteBillingSearchPerameter");
        localStorage.removeItem("SelecteBillingSearchPerameter");
        SessionHelper.SelecteBillingSearchPerameter = null;
    }

    static setAffiliateMessage(messageTitle) {
        localStorage.setItem("AffiliateMessage", messageTitle);
    }

    static getAffiliateMessage(): string {
        let affiliateMessage = localStorage.getItem("AffiliateMessage");
        if (affiliateMessage) {
            return affiliateMessage;
        } else {
            return '';
        }
    }

    static setCustomerHasLeftCRMStatus(crmStatus: boolean = false): void{
        if(crmStatus){
            localStorage.setItem("HasCustomerLeftCRM", 'true');
        }else{
            localStorage.removeItem("HasCustomerLeftCRM");
        }
    }

    static checkHasCustomerLeftCRM(): boolean {
        const hasCustomerLeftCRM = localStorage.getItem("HasCustomerLeftCRM");
        if (hasCustomerLeftCRM) {
            return true;
        } else {
            return false;
        }
    }


     static setUserProfileDetail(profileDetail) {
        this.userProfileDetail = profileDetail;
        let userProfileDetails = CryptoJS.AES.encrypt(JSON.stringify(profileDetail), this.encryptSecretKey).toString();
        localStorage.setItem('UserDetails', userProfileDetails);
    }

    static getUserProfileDetail() {
        //return (this.userProfileDetail) ? this.userProfileDetail : false;
        let profileDetails = localStorage.getItem('UserDetails') ? localStorage.getItem('UserDetails') : false;
        if (profileDetails) {
            const bytes = CryptoJS.AES.decrypt(profileDetails, this.encryptSecretKey);
            if (bytes.toString()) {
                return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            } else {
                return this.userProfileDetail;
            }
        } else {
            return this.userProfileDetail;
        }
    }

}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/helpers/session.helper.ts